'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserSetting } from '../../Entities/User/UserSetting';
export class UserSettingRepository extends CoreRepository {
  /*
    public getUserSetting(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getUserSetting(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let UserSetting = new UserSetting();
            UserSetting.hydrate(response);

            return UserSetting;
        });
    }

    public createUserSetting(payload: object = {}){  
    return this.webAPI.createUserSetting(payload)
      .then( response => {
        let UserSetting = new UserSetting();
        UserSetting.hydrate(response);

        return UserSetting;
      });
    }
    */
  public updateUserSetting(userId: number, payload: object = {}) {
    return this.webAPI.updateUserSetting(userId, payload).then((response) => {
      const userSetting = new UserSetting();
      userSetting.hydrate(response);

      return UserSetting;
    });
  }
  /*
    public removeUserSetting( ){
        return this.webAPI.removeUserSetting()
        .then( response => {
            return response;
        });
    }
    */
}
